import React from "react";

import { IgFilterAutocomplete, IgSelect } from "@intelligems/ig-theme";
import { CountryCodesFilterType, CountryEnum } from "@intelligems/ig-types";
import { MenuItem, Stack } from "@mui/material";

import { countryCodesFilterTypeList } from "./utils";

interface CountryCodesFilterProps {
  selectedValues: string[];
  countryCodesFilterType: CountryCodesFilterType;
  allDataOptions: string[];
  onFilterTypeChange: (value: string) => void;
  onValuesChange: (values: string[]) => void;
}

export const CountryCodesFilter = ({
  selectedValues,
  countryCodesFilterType,
  allDataOptions,
  onFilterTypeChange,
  onValuesChange,
}: CountryCodesFilterProps) => (
  <Stack direction="row" spacing={1} alignItems="flex-start">
    <IgSelect
      sx={{ flexShrink: 0 }}
      size="small"
      variant="outlined"
      value={countryCodesFilterType}
      onChange={(e) => onFilterTypeChange(e.target.value)}
    >
      {countryCodesFilterTypeList.map(({ key, label }) => (
        <MenuItem key={key} value={key}>
          {label}
        </MenuItem>
      ))}
    </IgSelect>
    <Stack sx={{ flex: 1, minWidth: 0 }}>
      <IgFilterAutocomplete
        selectedValues={selectedValues}
        onChange={(values) => onValuesChange(values)}
        filterKey="countryCodes"
        allDataOptions={allDataOptions}
        placeholder={selectedValues.length ? "" : "Countries"}
        disableCloseOnSelect={true}
        getOptionDisabled={(option) => option === null}
        getOptionLabel={(option) =>
          `${CountryEnum[option] ?? "Unknown"} ${option ? `(${option})` : ""}`
        }
      />
    </Stack>
  </Stack>
);
